import { matchPath } from 'react-router-dom'
import { SecurityCategory_CategoryCode } from '../proto/generated/security'
import { WidgetTypes } from '../components/widgetDashboard/widgetDashboard.enums'
import ROUTES from '../assets/routes'

/** Categories that can contain cash underlyings with F&O (hasFo). */
export const FO_UNDERLYING_CATEGORY_CODES: SecurityCategory_CategoryCode[] = [
    SecurityCategory_CategoryCode.ALL,
    SecurityCategory_CategoryCode.STOCKS,
    SecurityCategory_CategoryCode.INDEX,
]

/**
 * Scalper / option chain / OI / strategy builder pick a cash underlying
 * with hasFo — not futures, options, funds, bonds, or spreads.
 */
export function isFoUnderlyingSearchContext(args: {
    showOnlyFOSecurities?: boolean
    watchlistMode?: boolean
    widgetType?: WidgetTypes | string | number
}): boolean {
    if (args.watchlistMode) {
        return false
    }
    if (args.showOnlyFOSecurities) {
        return true
    }
    const widgetType = args.widgetType
    if (
        widgetType === WidgetTypes.OPTION_CHAIN ||
        widgetType === WidgetTypes.OI_CHART ||
        widgetType === WidgetTypes.OPEN_INTEREST_CHART ||
        widgetType === WidgetTypes.MULTI_STRIKE_CHART ||
        widgetType === WidgetTypes.FUTURE_CHART ||
        widgetType === WidgetTypes.ATM_OPTION_CHART ||
        widgetType === WidgetTypes.OPTION_CHART
    ) {
        return true
    }
    return Boolean(
        matchPath(ROUTES.optionChain, window.location.pathname) ||
            matchPath(ROUTES.optionWizard, window.location.pathname) ||
            matchPath(ROUTES.strategyBuilder, window.location.pathname) ||
            matchPath(ROUTES.openInterest, window.location.pathname) ||
            matchPath(ROUTES.openInterestChange, window.location.pathname) ||
            matchPath(ROUTES.multiStrikeChart, window.location.pathname) ||
            matchPath(ROUTES.scalper, window.location.pathname) ||
            matchPath(ROUTES.embeddedScalper, window.location.pathname)
    )
}

export function filterCategoriesForFoUnderlyingSearch<T extends { code: SecurityCategory_CategoryCode }>(
    categories: T[]
): T[] {
    const allowed = new Set(FO_UNDERLYING_CATEGORY_CODES)
    return categories.filter((category) => allowed.has(category.code))
}
